module.exports = __webpack_public_path__ + "img/crop1_active.a43779db.png";